// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Z8b","icon":"az__8b"};